import { render } from "./Selector.vue?vue&type=template&id=5e0db74a&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"

import "./Selector.vue?vue&type=style&index=0&id=5e0db74a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0db74a"]])

export default __exports__